import { render, staticRenderFns } from "./CenterView.vue?vue&type=template&id=1ed48ed0&scoped=true&"
import script from "./CenterView.vue?vue&type=script&lang=js&"
export * from "./CenterView.vue?vue&type=script&lang=js&"
import style0 from "./CenterView.vue?vue&type=style&index=0&id=1ed48ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed48ed0",
  null
  
)

export default component.exports